import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { userId: Number }

  connect() {
    this.#applyStyle()
  }

  #applyStyle() {
    const container = this.element.closest("[data-current-user-id]")
    const currentUserId = container ? parseInt(container.dataset.currentUserId, 10) : null
    const isOwn = currentUserId && currentUserId === this.userIdValue

    if (isOwn) {
      this.element.classList.add("chat-message-own")
    } else {
      this.element.classList.add("chat-message-other")
    }
  }
}
